export const DOC_FLOW_SCOPE_BUILDING_GROUPS_FIELD_QA_NAME =
  'docFlowScopeBuildingGroups'
